
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/news",
      function () {
        return require("private-next-pages/[lang]/news/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/news"])
      });
    }
  